export default __webpack_public_path__ + "static/media/kyc-completed.f5ecd60a.png";